var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters } from 'vuex';
import { ACCOUNT } from '@/stores/defs';
var profileMixin = {
    computed: __assign({}, mapGetters({
        customer: ACCOUNT.GET_CUSTOMER,
    }), { customerName: function () {
            var customer = this.customer;
            var name = (customer) ? (customer.firstName || customer.lastName) : 'Anonymous';
            return name;
        } }),
};
export default profileMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/profileMixin.ts
// module id = fDxx
// module chunks = 18